import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, mergeProps as _mergeProps, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-e9e8587a")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "p-d-flex p-jc-between p-flex-column p-flex-sm-row" }
const _hoisted_3 = { class: "toolbar_left" }
const _hoisted_4 = { class: "p-float-label p-input-icon-left p-mb-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_6 = {
  class: "filled",
  for: "search"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableSkeleton = _resolveComponent("TableSkeleton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.requestPending && !_ctx.dataset && _ctx.firstLoading)
      ? (_openBlock(), _createBlock(_component_TableSkeleton, {
          key: 0,
          columns: 5,
          rows: 10
        }))
      : (_openBlock(), _createBlock(_component_DataTable, _mergeProps({
          key: 1,
          ref: "dt",
          filters: _ctx.filters,
          "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filters = $event)),
          lazy: true,
          loading: _ctx.isLoading,
          paginator: true,
          rows: 10,
          "rows-per-page-options": [10, 20, 50, 100],
          showFilterOperator: false,
          stateKey: _ctx.stateKey,
          totalRecords: _ctx.totalRecords,
          value: _ctx.dataset,
          "auto-layout": "",
          breakpoint: "768px",
          dataKey: "id",
          compareSelectionBy: "equals",
          filterDisplay: "menu",
          responsiveLayout: "scroll",
          stateStorage: "session",
          "striped-rows": ""
        }, _ctx.$attrs, {
          onPage: _ctx.onPage,
          onSort: _ctx.onSort
        }), _createSlots({
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.no_records_found')), 1)
          ]),
          loading: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.loading')), 1)
          ]),
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "columns", {
              onApplyFilter: _ctx.onApplyFilter,
              onClearFilter: _ctx.onClearFilter
            }, undefined, true),
            (_ctx.showActions)
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 0,
                  header: _ctx.$t('common.actions'),
                  class: "column-header-right p-text-right",
                  style: {"min-width":"150px","width":"150px"}
                }, {
                  body: _withCtx(({data}) => [
                    _createElementVNode("div", {
                      class: "p-d-flex p-ai-center p-jc-end",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent","stop"]))
                    }, [
                      (_ctx.$attrs.onEdit)
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            class: "p-button-warning p-mr-1",
                            icon: "pi pi-pencil",
                            onClick: _withModifiers(($event: any) => (_ctx.$emit('edit', data)), ["stop"])
                          }, null, 8, ["onClick"])), [
                            [
                              _directive_tooltip,
                              _ctx.$t('common.edit'),
                              void 0,
                              { bottom: true }
                            ]
                          ])
                        : _createCommentVNode("", true),
                      (_ctx.$attrs.onDelete)
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            class: "p-button-danger p-mr-1",
                            icon: "pi pi-trash",
                            onClick: _withModifiers(($event: any) => (_ctx.onDelete(data)), ["stop"])
                          }, null, 8, ["onClick"])), [
                            [
                              _directive_tooltip,
                              _ctx.$t('common.delete'),
                              void 0,
                              { bottom: true }
                            ]
                          ])
                        : _createCommentVNode("", true),
                      _renderSlot(_ctx.$slots, "actions", { data: data }, undefined, true)
                    ])
                  ]),
                  _: 3
                }, 8, ["header"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, [
          (_ctx.showHeader)
            ? {
                name: "header",
                fn: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_Button, {
                        label: _ctx.$t('common.refresh'),
                        class: "p-button-outlined",
                        icon: "pi pi-refresh",
                        type: "button",
                        onClick: _ctx.refresh
                      }, null, 8, ["label", "onClick"]),
                      _createVNode(_component_Button, {
                        label: _ctx.$t('common.reset'),
                        class: "p-button-outlined",
                        icon: "pi pi-filter-slash",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClearFilter()))
                      }, null, 8, ["label"]),
                      _renderSlot(_ctx.$slots, "toolbarLeft", {}, undefined, true)
                    ]),
                    (_ctx.showGlobalFilter)
                      ? (_openBlock(), _createElementBlock("form", {
                          key: 0,
                          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onGlobalFilterSubmit && _ctx.onGlobalFilterSubmit(...args)), ["prevent"]))
                        }, [
                          _createElementVNode("span", _hoisted_4, [
                            _hoisted_5,
                            _createVNode(_component_InputText, {
                              id: "search",
                              modelValue: _ctx.filters.global.value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters.global.value = $event)),
                              style: {"width":"100%"},
                              onChange: _ctx.onGlobalFilterSubmit
                            }, null, 8, ["modelValue", "onChange"]),
                            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('common.search_placeholder')), 1)
                          ])
                        ], 32))
                      : _createCommentVNode("", true)
                  ])
                ])
              }
            : undefined
        ]), 1040, ["filters", "loading", "stateKey", "totalRecords", "value", "onPage", "onSort"]))
  ]))
}